import React from "react";
import { useIntl } from 'react-intl';

// Components
import {  Form } from 'Components';
import Slider from 'Components/Slider';
import TriggerLandmark from "Modules/alerts/components/wizardAlert/common/components/TriggerLandmark";


export const OBDII = (props) => {

    const { value, onChange, formRef, triggers } = props
    const { messages } = useIntl()

    return (
        <Form ref={formRef} >
            <div style={{ marginTop: 30 }}>
                <label className="input-normal-label">{messages['alertsNewAlert_triggerAlertWhen']}</label>
                <div className="form-item" style={{ padding: "15px 0px 5px" }}>
                    <div style={{ width: '100%' }}>
                        <label>{messages['alertsNewAlert_batteryVoltage']}</label>
                        <Slider
                            min={1}
                            max={100}
                            value={value.batteryVoltaje}
                            onChange={(event) => { onChange({ ...value, batteryVoltaje: event }) }}
                            sliderOneColor={false}
                            showValue
                            valueLabelDisplay={'off'}
                            measure={'v'}
                        />
                    </div>
                </div>
                <div className="form-item" style={{ padding: "5px 0" }}>
                    <div style={{ width: '100%' }}>
                        <label>{messages['alertsNewAlert_coolantTempIs']}</label>
                        <Slider
                            min={1}
                            max={100}
                            value={value.coolantTempFv}
                            onChange={(event) => { onChange({ ...value, coolantTempFv: event }) }}
                            sliderOneColor={false}
                            showValue
                            valueLabelDisplay={'off'}
                            measure={'°F'}
                        />
                    </div>
                </div>
                <div className="form-item" style={{ padding: "5px 0" }}>
                    <div style={{ width: '100%' }}>
                        <label>{messages['alertsNewAlert_engineSpeedIsGreaterThan']}</label>
                        <Slider
                            min={1}
                            max={100}
                            value={value.engineSpeed}
                            onChange={(event) => { onChange({ ...value, engineSpeed: event }) }}
                            sliderOneColor={false}
                            showValue
                            valueLabelDisplay={'off'}
                            measure={'rpm'}
                        />
                    </div>
                </div>
                <div className="form-item" style={{ padding: "5px 0" }}>
                    <div style={{ width: '100%' }}>
                        <label>{messages['alertsNewAlert_fuelLevelIsLessThan']}</label>
                        <Slider
                            min={1}
                            max={100}
                            value={value.fuelLevel}
                            onChange={(event) => { onChange({ ...value, fuelLevel: event }) }}
                            sliderOneColor={false}
                            showValue
                            valueLabelDisplay={'off'}
                            measure={'%'}
                        />
                    </div>
                </div>
                <div className="form-item" style={{ padding: "5px 0" }}>
                    <div style={{ width: '100%' }}>
                        <label>{messages['alertsNewAlert_fuelRemainingIsLessThan']}</label>
                        <Slider
                            min={1}
                            max={100}
                            value={value.fuelRemainingGallons}
                            onChange={(event) => { onChange({ ...value, fuelRemainingGallons: event }) }}
                            sliderOneColor={false}
                            showValue
                            valueLabelDisplay={'off'}
                            measure={'gal'}
                        />
                    </div>
                </div>
                <div className="form-item" style={{ padding: "5px 0" }}>
                    <div style={{ width: '100%' }}>
                        <label>{messages['alertsNewAlert_throttlePositionIsGreaterThan']}</label>
                        <Slider
                            min={1}
                            max={100}
                            value={value.throttlePosition}
                            onChange={(event) => { onChange({ ...value, throttlePosition: event }) }}
                            sliderOneColor={false}
                            showValue
                            valueLabelDisplay={'off'}
                            measure={'%'}
                        />
                    </div>
                </div>
                <div className="form-item" style={{ padding: "5px 0" }}>
                    <div style={{ width: '100%' }}>
                        <label>{messages['alertsNewAlert_seatbeltFastenedAtSpeedsGreaterThan']}</label>
                        <Slider
                            min={50}
                            max={500}
                            value={value.seatbeltSpeedGreater}
                            onChange={(event) => { onChange({ ...value, seatbeltSpeedGreater: event }) }}
                            sliderOneColor={false}
                            showValue
                            valueLabelDisplay={'off'}
                            measure={'mph'}
                        />
                    </div>
                </div>
                <div className="form-item" style={{ padding: "5px 0" }}>
                    <div style={{ width: '100%' }}>
                        <label>{messages['alertsNewAlert_odometer']}</label>
                        <Slider
                            min={1}
                            max={100}
                            value={value.ecuOdometer}
                            onChange={(event) => { onChange({ ...value, ecuOdometer: event }) }}
                            sliderOneColor={false}
                            showValue
                            valueLabelDisplay={'off'}
                        />
                    </div>
                </div>
            </div>
        </Form>
    );
}
